export function userFullName(user) {
  if (user.given_name && user.family_name) {
    return `${user.given_name} ${user.family_name}`
  } else {
    return user.given_name || user.family_name || null
  }
}
